/* Vila Pure — lender "Kolagen za bolove u zglobovima" (sections/vl-zglobovi.liquid, vl-zglobovi-2.liquid).
   Zamenjuje Design Canvas runtime iz izvora (landers-src/kolagen-zglobovi): marker u naslovu, galerija,
   tajmer, akcija, Rapi paketi, korpa, česta pitanja, rail sastojaka i sticky dugme.

   Akcija i korpa rade kao na ostalim lenderima (snippets/vila-clg-product-form.liquid,
   assets/vila-belly-support.js): isti localStorage ključevi, isti /discount/ iframe, ista fioka korpe i
   isti "Kupi odmah" (isprazni korpu, doda paket, vodi na kasu). Kupac koji je akciju aktivirao na
   drugom lenderu ovde je vidi kao aktiviranu, i obrnuto. */
(function () {
  'use strict';
  if (window.__vlZg) return;
  window.__vlZg = true;

  var ACTIVE_KEY = 'vilaDiscountActivated';
  var CODE_KEY = 'vilaDiscountCode';
  var VALUE_KEY = 'vilaDiscountValue';
  var CLARITY_KEY = 'vilaOfferClaim';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 12l5 5L17 7M9 17l10-10"></path></svg>';

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function readStore(type, key) { try { return window[type].getItem(key); } catch (e) { return null; } }
  function writeStore(type, key, value) { try { window[type].setItem(key, value); } catch (e) { /* privatni režim */ } }
  function smoothTo(el) {
    if (el) el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Marker u naslovu ---------- */
  (function () {
    var marks = $$('.vl-zg-mark');
    if (!marks.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      marks.forEach(function (m) { m.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    });
    marks.forEach(function (m) { io.observe(m); });
  })();

  /* ---------- Galerija: strelice, sličice, brojač, prevlačenje prstom ---------- */
  $$('[data-vl-zg-gallery]').forEach(function (g) {
    var main = $('[data-vl-zg-main]', g);
    var thumbs = $$('[data-vl-zg-thumb]', g);
    var counter = $('[data-vl-zg-counter]', g);
    if (!main || thumbs.length < 2) return;
    var current = 0;

    function show(k) {
      current = (k + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      var src = t.getAttribute('data-full');
      if (src && main.getAttribute('src') !== src) {
        main.classList.add('is-loading');
        main.onload = main.onerror = function () { main.classList.remove('is-loading'); };
        main.src = src;
      }
      thumbs.forEach(function (o, n) {
        o.style.borderColor = n === current ? '#3c768c' : 'transparent';
        o.setAttribute('aria-current', n === current ? 'true' : 'false');
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + thumbs.length;
      var strip = t.parentElement;
      var tr = t.getBoundingClientRect();
      var sr = strip.getBoundingClientRect();
      var delta = (tr.left - sr.left) - (sr.width - tr.width) / 2;
      if (Math.abs(delta) > 2) strip.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = $('[data-vl-zg-prev]', g);
    var next = $('[data-vl-zg-next]', g);
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    var sx = 0, sy = 0, tracking = false;
    main.parentElement.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    main.parentElement.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  });

  /* ---------- Tajmer do ponoći (samo prikaz) ---------- */
  $$('[data-vl-zg-timer]').forEach(function (timer) {
    var h = $('[data-vl-zg-t="h"]', timer);
    var m = $('[data-vl-zg-t="m"]', timer);
    var s = $('[data-vl-zg-t="s"]', timer);
    if (!h || !m || !s) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now.getTime());
      end.setHours(24, 0, 0, 0);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Česta pitanja ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-vl-zg-acc]') : null;
    if (!btn) return;
    btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });

  /* ---------- Rail sastojaka: prevlačenje mišem ---------- */
  $$('[data-vl-zg-rail]').forEach(function (rail) {
    var down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
      if (moved) rail.scrollLeft = startLeft - dx;
    });
    function end() {
      if (!down) return;
      down = false;
      if (!moved) return;
      var left = rail.scrollLeft;
      rail.classList.remove('is-dragging');
      /* vrati snap, ali pusti da se traka smiri na najbližoj kartici bez skoka */
      rail.scrollLeft = left;
      rail.addEventListener('click', function swallow(ev) {
        ev.preventDefault(); ev.stopPropagation();
        rail.removeEventListener('click', swallow, true);
      }, true);
      setTimeout(function () { moved = false; }, 0);
    }
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointerleave', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  /* ---------- Rail sastojaka: strelice (vidljive samo na desktopu, CSS) ---------- */
  $$('.vl-zg-ing').forEach(function (sec) {
    var rail = $('[data-vl-zg-rail]', sec);
    var prev = $('[data-vl-zg-ing-prev]', sec);
    var next = $('[data-vl-zg-ing-next]', sec);
    if (!rail || !prev || !next) return;
    function step() {
      var card = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- Sticky dugme (mobilni) ---------- */
  var sticky = $('[data-vl-zg-sticky]');
  if (sticky) {
    document.body.classList.add('vl-zg-has-sticky');
    var hero = $('[data-hero-img]');
    var setShow = function (show) {
      var v = show ? '1' : '0';
      if (sticky.getAttribute('data-show') !== v) sticky.setAttribute('data-show', v);
    };
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        setShow(!en.isIntersecting && en.boundingClientRect.bottom < 0);
      }).observe(hero);
    } else {
      var onScroll = function () { setShow(window.scrollY > 600); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Recenzije (sekcija 2/2) ----------
     Žive Ali Reviews recenzije preko assets/vp-ali-reviews.js, istog klijenta koji koristi PDP (bez API
     ključa). Taj fajl se učitava kasnije od ovog, zato se kreće posle DOMContentLoaded. Recenzije se
     traže tek kad blok priđe ekranu; one koje pominju ključne reči idu prve, ostale po datumu.
     Bez recenzija ili ako servis ne odgovori, blok ostaje skriven. */
  function initReviews() {
    $$('[data-vl-zg-reviews]').forEach(function (box) {
      var api = window.VPAliReviews;
      var shop = box.getAttribute('data-shop');
      var pid = box.getAttribute('data-product-id');
      var list = $('[data-vl-zg-rv-list]', box);
      var more = $('[data-vl-zg-rv-more]', box);
      var tpl = $('[data-vl-zg-rv-tpl]', box);
      if (!api || !shop || !pid || !list || !tpl || !tpl.content) { box.hidden = true; return; }

      var PER = Math.max(1, parseInt(box.getAttribute('data-per'), 10) || 5);
      var MAX = 150;
      var months = (box.getAttribute('data-months') || '').split(',').map(function (m) { return m.trim(); });
      var stems = (box.getAttribute('data-keywords') || '').split(',')
        .map(function (k) { return k.trim().toLowerCase(); })
        .filter(Boolean)
        .map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      var focusRx = stems.length ? new RegExp('(?:^|[^a-zčćžšđ])(?:' + stems.join('|') + ')', 'i') : null;
      var ordered = [];
      var shown = 0;
      var started = false;

      function plural(n) {
        var d = n % 10, h = n % 100;
        if (d === 1 && h !== 11) return box.getAttribute('data-count-one') || '';
        if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return box.getAttribute('data-count-few') || '';
        return box.getAttribute('data-count-many') || '';
      }
      function paintStars(holder, rating) {
        $$('svg', holder).forEach(function (svg, i) { svg.style.color = i < rating ? '' : '#d6dde0'; });
      }
      function formatDate(raw) {
        var m = String(raw || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!m) return '';
        var month = months[parseInt(m[2], 10) - 1] || m[2];
        return parseInt(m[3], 10) + ' ' + month + ' ' + m[1];
      }
      function initials(name) {
        var letters = String(name || '').replace(/[^A-Za-zČĆŽŠĐčćžšđ]/g, '');
        return letters.slice(0, 2).toUpperCase();
      }
      function card(r) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        var name = String(r.author || '').trim();
        var f = function (k) { return node.querySelector('[data-f="' + k + '"]'); };
        f('name').textContent = name;
        f('name').hidden = !name;
        f('initials').textContent = initials(name);
        f('initials').hidden = !initials(name);
        f('verified').hidden = !r.verified_purchase;
        var rating = Math.max(0, Math.min(5, Math.round(Number(r.star) || 0)));
        paintStars(f('stars'), rating);
        f('stars').setAttribute('aria-label', rating + '/5');
        f('date').textContent = formatDate(r.created_at);
        f('body').textContent = String(r.content || '').trim();
        return node;
      }
      function showMore() {
        var next = ordered.slice(shown, shown + PER);
        var frag = document.createDocumentFragment();
        next.forEach(function (r) { frag.appendChild(card(r)); });
        list.appendChild(frag);
        shown += next.length;
        if (more) more.hidden = shown >= ordered.length;
      }
      function summary(items, total) {
        var sum = 0;
        items.forEach(function (r) { sum += Number(r.star) || 0; });
        var avg = items.length ? Math.round((sum / items.length) * 10) / 10 : 0;
        var wrap = $('[data-vl-zg-rv-summary]', box);
        if (!wrap || !avg) return;
        $('[data-vl-zg-rv-avg]', box).textContent = String(avg).replace('.', ',');
        paintStars($('[data-vl-zg-rv-avg-stars]', box), Math.round(avg));
        $('[data-vl-zg-rv-count]', box).textContent = total + ' ' + plural(total);
        wrap.hidden = false;
      }
      function start() {
        if (started) return;
        started = true;
        var stream = api.createStream({ shopDomain: shop, productId: pid, order: 'newest' });
        stream.ensure(MAX).then(function (st) {
          var items = st.items.slice();
          $$('.vl-zg-rv-skel', list).forEach(function (el) { el.remove(); });
          if (!items.length) { box.hidden = true; return; }
          var focus = [];
          var rest = [];
          items.forEach(function (r) { (focusRx && focusRx.test(String(r.content || '')) ? focus : rest).push(r); });
          ordered = focus.concat(rest);
          summary(items, st.exhausted ? items.length : Math.max(st.total, items.length));
          showMore();
        }).catch(function (err) {
          if (window.console) console.warn('[vl-zglobovi] recenzije:', err);
          box.hidden = true;
        });
      }

      if (more) more.addEventListener('click', showMore);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (en) { return en.isIntersecting; })) return;
          io.disconnect();
          start();
        }, { rootMargin: '900px 0px' });
        io.observe(box);
      } else {
        start();
      }
    });
  }
  /* Odloženi skriptovi se izvršavaju dok je readyState već 'interactive', pa se ne sme krenuti odmah:
     vp-ali-reviews.js je kasnije na strani. DOMContentLoaded stiže tek kad su svi odloženi gotovi. */
  (function bootReviews() {
    if (window.VPAliReviews || document.readyState === 'complete') { initReviews(); return; }
    var done = false;
    var go = function () { if (done) return; done = true; initReviews(); };
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
  })();

  /* ---------- Buy box: akcija, Rapi paketi, korpa ---------- */
  var box = $('[data-vl-zg-buybox]');
  if (box) initBuyBox(box);

  function initBuyBox(box) {
    var CODE = (box.getAttribute('data-code') || '').trim();
    var DROP = Number(box.getAttribute('data-drop')) || 0;
    var STRIP = box.getAttribute('data-strip') || '';
    var form = $('[data-vl-zg-form]', box);
    var packs = $('[data-vl-zg-packs]', box);
    var fallback = $('[data-vl-zg-fallback]', box);
    var claim = $('[data-vl-zg-claim]', box);
    var claimLabel = $('[data-vl-zg-claim-label]', box);
    var applied = $('[data-vl-zg-applied]', box);
    var atc = $('[data-vl-zg-atc]', box);
    var atcLabel = $('[data-vl-zg-atc-label]', box);
    var atcChevron = $('[data-vl-zg-atc-chevron]', box);
    var buyNowBtn = $('[data-vl-zg-buy-now]', box);
    var errorEl = $('[data-vl-zg-error]', box);
    var countEl = $('[data-vl-zg-count]', box);
    var atcText = atcLabel ? atcLabel.textContent : '';
    var cache = [];
    var busy = false;
    var lastSubmitter = null;
    var addedTimer = null;

    /* -- akcija -- */
    /* Sesija akcije iz teme (assets/vila-discount-session.js): kolačić vila_discount_offer, 5 h.
       Bez njega tema pri sledećem učitavanju skida 300/600-poklon iz korpe i briše ključeve. */
    function hasSession() { return /(?:^|;\s*)vila_discount_offer=/.test(document.cookie); }
    function startSession() {
      if (window.vilaDiscountSession && typeof window.vilaDiscountSession.activate === 'function') {
        window.vilaDiscountSession.activate();
        return;
      }
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = 'vila_discount_offer=1; Max-Age=18000; Path=/; SameSite=Lax' + secure;
    }

    function isClaimed() {
      if (!CODE || readStore('localStorage', ACTIVE_KEY) !== 'true' || !hasSession()) return false;
      return (readStore('localStorage', CODE_KEY) || '').toLowerCase() === CODE.toLowerCase();
    }

    function applyCode(code) {
      if (!code) return;
      var frame = document.getElementById('vila-discount-iframe');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'vila-discount-iframe';
        frame.style.display = 'none';
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('tabindex', '-1');
        document.body.appendChild(frame);
      }
      frame.src = '/discount/' + encodeURIComponent(code) + '?v=' + Date.now() + '&redirect=/cart';

      $$('form[action^="/cart"], form[action^="/checkout"]').forEach(function (f) {
        if (f.matches('form[action^="/cart/add"]')) return;
        var input = f.querySelector('input[name="discount"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'discount';
          f.appendChild(input);
        }
        input.value = code;
      });
      $$('a[href^="/checkout"]').forEach(function (a) {
        a.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=/checkout');
      });
    }

    /* Isti "hvatač" kase kao na ostalim lenderima; zastavica sprečava dupli listener. */
    if (!window.vilaCheckoutDiscountListenerAdded) {
      window.vilaCheckoutDiscountListenerAdded = true;
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"]') : null;
        if (!trigger || readStore('localStorage', ACTIVE_KEY) !== 'true') return;
        var code = readStore('localStorage', CODE_KEY) || CODE;
        if (!code) return;
        if (trigger.tagName === 'A') {
          e.preventDefault();
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
          return;
        }
        var f = trigger.closest('form');
        if (!f) return;
        var input = f.querySelector('input[name="discount"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'discount';
          f.appendChild(input);
        }
        input.value = code;
      }, true);
    }

    function showClaimed() {
      if (claim) {
        claim.setAttribute('data-claimed', 'true');
        if (claimLabel && box.getAttribute('data-done')) claimLabel.textContent = box.getAttribute('data-done');
      }
      if (applied) applied.hidden = false;
      decorate();
    }

    if (claim) {
      claim.addEventListener('click', function (e) {
        e.preventDefault();
        if (!CODE) return;
        startSession();
        writeStore('localStorage', ACTIVE_KEY, 'true');
        writeStore('localStorage', CODE_KEY, CODE);
        writeStore('localStorage', VALUE_KEY, String(DROP));
        applyCode(CODE);
        showClaimed();
        if (readStore('sessionStorage', CLARITY_KEY) !== 'true' && typeof window.clarity === 'function') {
          window.clarity('event', 'offerClaimed');
          writeStore('sessionStorage', CLARITY_KEY, 'true');
        }
        smoothTo(document.getElementById('paketi'));
      });
    }

    /* -- cene -- */
    function parsePrice(text) {
      var m = String(text || '').replace(/ /g, ' ').match(/\d[\d.,]*/);
      if (!m) return null;
      var raw = m[0].replace(/[.,]+$/, '');
      if (/[.,]\d{2}$/.test(raw)) {
        var dec = raw.charAt(raw.length - 3);
        var grp = dec === ',' ? '.' : ',';
        return { value: parseFloat(raw.split(grp).join('').replace(dec, '.')), raw: raw, decimals: 2, dec: dec, grp: grp };
      }
      var sep = (raw.match(/[.,]/) || [''])[0];
      return { value: parseInt(raw.replace(/[.,]/g, ''), 10), raw: raw, decimals: 0, dec: sep === '.' ? ',' : '.', grp: sep };
    }
    function formatLike(p, value) {
      var bits = value.toFixed(p.decimals).split('.');
      var ints = p.grp ? bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, p.grp) : bits[0];
      return p.decimals ? ints + p.dec + bits[1] : ints;
    }
    /* Cena u Rapi podacima (RSD), za slučaj da je konverter valuta (BUCKS, kupci iz BiH) već
       pretvorio prikaz u KM pre nego što smo ga pročitali. */
    function rapiBase(i) {
      var data = window['rapi_bundle_' + box.getAttribute('data-product-id')];
      var o = data && data.offers && data.offers[i];
      if (!o) return null;
      var full = Number(o.comparedPrice || o.subTotal) || 0;
      var qty = Number(o.quantity) || 1;
      var dv = Number(o.discount_value) || 0;
      var type = o.discount_type || o.discountType;
      var price = null;
      if (type === 'default') price = full;
      else if (type === 'amount') price = full - dv * qty;
      else if (type === 'percentage') price = full * (1 - dv / 100);
      price = price === null ? null : Math.round(price);
      return price > 0 ? price : null;
    }
    function setMoney(el, text) {
      if (window.VilaMarketMoney && typeof window.VilaMarketMoney.setBaseText === 'function') {
        window.VilaMarketMoney.setBaseText(el, text);
        return;
      }
      if (el.getAttribute('data-vl-zg-set') === text) return;
      el.setAttribute('data-vl-zg-set', text);
      el.textContent = text;
    }
    function bars() { return packs ? $$('.rapi-bundles__bar', packs) : []; }
    function priceEl(bar) {
      return $('.rapi-bundles__bar-price .money', bar) || $('.rapi-bundles__bar-price', bar);
    }
    /* Izabrani paket: radio koji Rapi drži, pa Rapi-jeva klasa, pa poslednji poznati izbor.
       Rapi skida svoj marker pre nego što postavi novi; bez pamćenja bi izbor u tom razmaku
       skočio na prvi paket i nazad (isto rešenje kao sections/vp-pdp-main-product.liquid). */
    var lastBar = null;
    function selectedBar(list) {
      var k;
      for (k = 0; k < list.length; k++) {
        var r = $('input[type="radio"], input[type="checkbox"]', list[k]);
        if (r && r.checked) return (lastBar = list[k]);
      }
      for (k = 0; k < list.length; k++) {
        if (/selected|active|checked/i.test(list[k].className.split('is-selected').join(''))) return (lastBar = list[k]);
      }
      if (lastBar && list.indexOf(lastBar) > -1) return lastBar;
      return (lastBar = list[0] || null);
    }

    function decorate() {
      var list = bars();
      if (list.length && fallback) fallback.hidden = true;
      var claimed = isClaimed();
      var chosen = selectedBar(list);

      list.forEach(function (bar, i) {
        bar.classList.toggle('is-selected', bar === chosen);

        if (STRIP && !$('.vl-zg-strip', bar)) {
          var host = $('.rapi-bundles__bar-container', bar) || bar;
          var strip = document.createElement('span');
          strip.className = 'vl-zg-strip';
          strip.innerHTML = CHECK_SVG;
          strip.appendChild(document.createTextNode(STRIP));
          host.appendChild(strip);
        }

        var pe = priceEl(bar);
        if (!pe) return;
        if (!cache[i]) {
          var txt = (pe.textContent || '').replace(/\s+/g, ' ').trim();
          var parsed = /RSD/i.test(txt) ? parsePrice(txt) : null;
          if (parsed && parsed.value) cache[i] = { text: txt, p: parsed };
          else {
            var fromRapi = rapiBase(i);
            if (fromRapi) cache[i] = { text: fromRapi + ' RSD', p: { value: fromRapi, raw: String(fromRapi), decimals: 0, dec: ',', grp: '' } };
          }
        }
        var base = cache[i];
        if (!claimed || !DROP || !base || base.p.value <= DROP) return;

        setMoney(pe, base.text.replace(base.p.raw, formatLike(base.p, base.p.value - DROP)));

        /* Paket bez uštede nema precrtanu cenu; posle akcije je dobija (kao na ostalim lenderima). */
        if (!$('.rapi-bundles__bar-full-price', bar)) {
          var full = document.createElement('span');
          full.className = 'rapi-bundles__bar-full-price vl-zg-full-added';
          var money = document.createElement('span');
          money.className = 'rapi-money money';
          full.appendChild(money);
          var priceBox = $('.rapi-bundles__bar-price', bar);
          (priceBox || pe).insertAdjacentElement('afterend', full);
          setMoney(money, base.text);
        }
      });

      syncSticky(chosen);
    }

    function syncSticky(bar) {
      if (!sticky) return;
      var packOut = $('[data-vl-zg-sticky-pack]', sticky);
      var priceOut = $('[data-vl-zg-sticky-price]', sticky);
      var title = bar && $('.rapi-bundles__bar-title', bar);
      var pe = bar && priceEl(bar);
      var name = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      var price = pe ? pe.textContent.replace(/\s+/g, ' ').trim() : (box.getAttribute('data-product-price') || '');
      if (packOut && packOut.textContent !== name) packOut.textContent = name;
      if (priceOut && priceOut.textContent !== price) priceOut.textContent = price;
    }

    /* setTimeout, ne requestAnimationFrame: rAF stoji dok tab nije vidljiv, a konverter valuta
       menja cene i tada (sticky bi ostao sa starom cenom). */
    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; decorate(); }, 16);
    }
    if (packs) {
      new MutationObserver(queue).observe(packs, { childList: true, subtree: true, characterData: true });
      packs.addEventListener('change', queue);
      packs.addEventListener('click', function () { setTimeout(queue, 0); });
    }
    /* Ako se Rapi ne pojavi, kupac i dalje vidi cenu jednog pakovanja (forma radi i bez Rapi-ja). */
    setTimeout(function () { if (!bars().length && fallback) fallback.hidden = false; }, 6000);

    if (isClaimed()) {
      applyCode(CODE);
      showClaimed();
    } else {
      decorate();
    }

    /* -- korpa -- */
    function setBusy(on) {
      busy = on;
      if (form) form.classList.toggle('is-busy', on);
    }
    function showError(on) {
      if (errorEl) errorEl.hidden = !on;
    }
    function flashAdded() {
      if (!atcLabel) return;
      clearTimeout(addedTimer);
      atcLabel.textContent = box.getAttribute('data-atc-done') || atcText;
      if (atcChevron) atcChevron.style.display = 'none';
      addedTimer = setTimeout(function () {
        atcLabel.textContent = atcText;
        if (atcChevron) atcChevron.style.display = '';
      }, 1800);
    }
    function refreshCount() {
      if (!countEl) return;
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = Number(cart && cart.item_count) || 0;
          countEl.textContent = n > 99 ? '99+' : String(n);
          countEl.hidden = n < 1;
        })
        .catch(function () {});
    }
    function renderCart(state) {
      var sections = state && state.sections;
      if (!sections) return;
      var doc;
      if (sections['cart-icon-bubble']) {
        doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var cur = document.getElementById('cart-icon-bubble');
        var inc = doc.getElementById('cart-icon-bubble') || doc.body.firstElementChild;
        if (cur && inc) cur.innerHTML = inc.innerHTML;
      }
      if (sections['cart-drawer']) {
        doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        ['.js-content-heading', '.js-content-items', '.js-content-footer-cart-notes', '.js-content-footer-subtotal'].forEach(function (sel) {
          var drawer = document.getElementById('cartDrawerSection');
          var curEl = (drawer && drawer.querySelector(sel)) || document.querySelector(sel);
          var newEl = doc.querySelector(sel);
          if (curEl && newEl) curEl.innerHTML = newEl.innerHTML;
        });
        var buttons = document.querySelector('.js-content-footer-buttons');
        var newButtons = doc.querySelector('.js-content-footer-buttons');
        if (buttons && buttons.parentNode && newButtons && newButtons.parentNode) {
          buttons.parentNode.classList.toggle('hidden', newButtons.parentNode.classList.contains('hidden'));
        }
      }
    }
    function openDrawer() {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.dispatchEvent(new Event('triggetClick'));
      /* eslint-disable no-undef */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
      }
      /* eslint-enable no-undef */
    }

    function addToCart() {
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      setBusy(true);
      showError(false);
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status) throw new Error(data.description || 'cart/add');
            return data;
          });
        })
        .then(function (state) {
          if (isClaimed()) applyCode(CODE);
          renderCart(state);
          openDrawer();
          flashAdded();
          refreshCount();
        })
        .catch(function (err) {
          if (window.console) console.error('[vl-zglobovi] dodavanje u korpu:', err);
          showError(true);
        })
        .then(function () { setBusy(false); });
    }

    function buyNow() {
      var fd = new FormData(form);
      setBusy(true);
      showError(false);
      fetch(ROOT + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/clear');
          return fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add');
          var target = isClaimed()
            ? '/discount/' + encodeURIComponent(CODE) + '?redirect=/checkout'
            : ROOT + 'checkout';
          /* na vilapure.ba kapija prvo otvara EasySell, inače kasa */
          if (window.vilaCheckout) {
            Promise.resolve(window.vilaCheckout.go(target)).then(function (opened) {
              if (opened) setBusy(false);
            });
          } else {
            window.location.href = target;
          }
        })
        .catch(function (err) {
          if (window.console) console.error('[vl-zglobovi] kupi odmah:', err);
          showError(true);
          setBusy(false);
        });
    }

    if (form) {
      [atc, buyNowBtn].forEach(function (b) {
        if (b) b.addEventListener('click', function () { lastSubmitter = b; });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        var submitter = e.submitter || lastSubmitter;
        lastSubmitter = null;
        if (submitter && submitter.hasAttribute('data-vl-zg-buy-now')) buyNow();
        else addToCart();
      });
    }

    /* Povratak dugmetom Nazad (bfcache): dugmad ne smeju ostati zaključana. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      setBusy(false);
      if (isClaimed()) showClaimed();
    });
  }
})();
